export default function ValentinesDayScan(){
    return (
        <>
            <img src='scan-valentines-day-front.jpg' style={{maxWidth:'100%'}} />
            

        </>
    )
}